import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useSeo } from "@/hooks/useSeo";
import { siteStats } from "@/mocks/site";
import HeroCarousel from "./components/HeroCarousel";
import QuickCategories from "./components/QuickCategories";
import LatestUpdates from "./components/LatestUpdates";
import PopularSection from "./components/PopularSection";
import NewsPreview from "./components/NewsPreview";

export default function Home() {
  useSeo({
    title:
      "樱花动漫官网-最新动漫在线观看与资讯平台",
    description:
      "樱花动漫官网提供海量最新动漫资源、热门动画在线观看及丰富动漫资讯，覆盖多种动漫类别，满足动漫爱好者的所有需求。",
    keywords: "樱花动漫官网,动漫在线观看,最新动漫,动画资讯,樱花动漫,动漫推荐,动漫平台",
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroCarousel />
        <QuickCategories />
        <LatestUpdates />
        <PopularSection />
        <NewsPreview />

        <section className="w-full px-4 pb-14 pt-4 md:px-8">
          <div className="mx-auto w-full max-w-[1400px]">
            <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-primary-100 via-background-100 to-secondary-100 px-6 py-10 md:px-10 md:py-12">
              <i className="ri-heart-3-fill pointer-events-none absolute -right-4 -top-6 text-[140px] text-primary-200/50" />
              <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-[1.15fr_1fr]">
                <div>
                  <span className="font-label text-[11px] uppercase tracking-[0.2em] text-primary-700">
                    Join the community
                  </span>
                  <h2 className="mt-2 text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
                    把喜欢的作品，收进自己的樱花片单
                  </h2>
                  <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-700">
                    收藏、筛选、搜索，全部在本地完成，不需要注册。你只需要找到下一部想看的动画，然后安静地看完它。
                  </p>
                  <div className="mt-6 flex flex-wrap items-center gap-3">
                    <Link
                      to="/category"
                      className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                    >
                      <i className="ri-compass-3-line text-base" />
                      开始找番
                    </Link>
                    <Link
                      to="/about"
                      className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                    >
                      了解樱花动漫
                      <i className="ri-arrow-right-line text-sm" />
                    </Link>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  {siteStats.map((stat) => (
                    <div key={stat.label} className="rounded-lg border border-background-200/80 bg-background-50/80 p-4">
                      <p className="font-heading text-xl font-bold text-primary-600 md:text-2xl">{stat.value}</p>
                      <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}